import Cookies from 'universal-cookie';

const cookies = new Cookies();

const SESSION_DURATION_IN_SECONDS = 7200;

export const CookieKey = {
    RETURNING_USER: {key: "cp_last_login", duration: 0},
    BASIC_AUTH: {key: "cp_ba", duration: SESSION_DURATION_IN_SECONDS},
    USER_PROFILE: {key: "cp_user_profile", duration: SESSION_DURATION_IN_SECONDS},
    CONVERSATION_ID: {key: "cp_conversation_id", duration:SESSION_DURATION_IN_SECONDS}
}

const cookieOptions = {secure: true, sameSite: true}

export default class CookieService {

    static getCookie(key, defaultValue = undefined) {
        let cookieValue = cookies.get(key.key);

        if (cookieValue === undefined) {
            cookieValue = defaultValue;
        }

        return cookieValue;
    }

    static setCookie(key, cookieValue) {
        if (key.duration > 0) cookies.set(key.key, cookieValue, {...cookieOptions, path: '/', maxAge: key.duration});
        else cookies.set(key.key, cookieValue, cookieOptions);
    }

    static removeCookie(key) {
        cookies.remove(key.key);
    }

    static touchCookie(key) {
        let cookieValue = cookies.get(key.key);
        if (key.duration > 0) cookies.set(key.key, cookieValue, {
            ...cookieOptions,
            path: '/',
            maxAge: key.duration,
            secure: true
        });
        else cookies.set(key.key, cookieValue, cookieOptions);
        return cookieValue;
    }
}
